module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"My Profile":"My Profile","Purchases":"Purchases","Sign out":"Sign out"},"de":{"My Profile":"Mein Profil","Purchases":"Käufe","Sign out":"Abmelden"}}')
  delete Component.options._Ctor
}
